import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ResourceModule } from '../constants/constants';

@Component({
    selector: 'app-rich-text-editor',
    templateUrl: './rich-text-editor.component.html',
    styleUrl: './rich-text-editor.component.less',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RichTextEditorComponent implements OnInit, OnChanges {
  @Input() editorData: string = '';
  @Input() Module: string;
  @Output() newItemEvent = new EventEmitter<string>();

  editorConfig: any;
  editorContent: string = '';

  ngOnInit() {
    this.editorContent = this.editorData || '';
    this.initializeEditorConfig();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['editorData']) {
      const nextValue = changes['editorData'].currentValue || '';
      if (nextValue !== this.editorContent) {
        this.editorContent = nextValue;
      }
    }
  }

  initializeEditorConfig() {
    const baseConfig = {
      base_url: '/assets/tinymce',
      // Required from TinyMCE 7 onwards for self-hosted GPL builds.
      license_key: 'gpl',
      height: 500,
      menubar: true,
      promotion: false,
      plugins: [
        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
        'insertdatetime', 'media', 'table', 'help', 'wordcount', 'textcolor', 'colorpicker', 'hr', 'lineheight'
      ],
      toolbar: 'undo redo | formatselect | bold italic underline | ' +
               'forecolor backcolor | alignleft aligncenter alignright alignjustify | ' +
               'bullist numlist outdent indent | link image media | ' +
               'removeformat | help',
      menu: {
        file: { title: 'File', items: 'newdocument restoredraft | export print' },
        edit: { title: 'Edit', items: 'cut copy paste pastetext | selectall | searchreplace' },
        view: { title: 'View', items: 'code | fullscreen' },
        insert: { title: 'Insert', items: 'charmap | hr | insertdatetime' },
        format: { title: 'Format', items: 'superscript subscript codeformat | styles blocks fontfamily fontsize lineheight' },
        table: { title: 'Table', items: 'inserttable | cell row column | tableprops deletetable' },
        tools: { title: 'Tools', items: ' spelling spellcheckdialog | wordcount' }
      },
      help_tabs: ['shortcuts', 'keyboardnav'],
      content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
      statusbar: false,
      branding: false
    };

    // Module-specific configurations
    if (this.Module === ResourceModule) {
      baseConfig.height = 200;
      // Remove certain features for resource module
      baseConfig.toolbar = 'bold italic underline strikethrough | ' +
                           'forecolor backcolor | alignleft aligncenter alignright alignjustify | ' +
                           'bullist numlist outdent indent | ' +
                           'removeformat | help';
    }

    this.editorConfig = baseConfig;
  }

  onEditorChange(content: string) {
    this.editorContent = content;
    this.newItemEvent.emit(content);
  }
}



